const red_button = {
    backgroundColor: '#D90E28',     // Arka plan rengi kırmızı
    color: 'white',              // Yazı rengi beyaz
    fontWeight: 'bold'           // Kalın yazı
  };
  
  export default red_button;
  